import React, { useMemo } from 'react';
import cn from 'classnames';
import _isString from 'lodash/isString';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {Object} props
 * @param {string} props.text
 * @param {number} props.trimLength
 * @param {boolean} props.preventLineBreak
 * @param {string} props.className
 * @param {string} props.tooltipClassName
 * @param {import('utils/types').TooltipPlacement} props.tooltipPlacement
 */
export default function OverflowText({
  text = '',
  trimLength = 100,
  preventLineBreak = false,
  className = '',
  tooltipClassName = '',
  tooltipPlacement = 'top'
}) {
  const { isTrimmed, trimmedText } = useMemo(() => {
    if (!_isString(text)) return { isTrimmed: false, trimmedText: '' };
    const isTrimmed = text.length > trimLength;
    const trimmedText = isTrimmed
      ? `${text.substring(0, trimLength)}...`
      : text;

    return { isTrimmed, trimmedText };
  }, [text, trimLength]);

  const showTooltip = isTrimmed || preventLineBreak;

  return (
    <UiKit.Tooltip disabled={!showTooltip}>
      <UiKit.Tooltip.Trigger>
        <p
          className={cn(styles.text, className, {
            [styles.oneLiner]: preventLineBreak
          })}
        >
          {trimmedText}
        </p>
      </UiKit.Tooltip.Trigger>
      <UiKit.Tooltip.Content
        placement={tooltipPlacement}
        innerClassName={cn(styles.tooltip, tooltipClassName)}
      >
        {text}
      </UiKit.Tooltip.Content>
    </UiKit.Tooltip>
  );
}
